<template>
<div>
       <b-card no-body class="mb-2 mt-4  w-100 ">
            <b-card-header v-on:click="changeAngel = !changeAngel"  header-tag="header" class=" w-100 h-100 p-0" role="tab">
              <div  v-b-toggle="dtgr.group.replace(' ','')" variant="info" class="head-mes">
                <div class="title-left pl-3">
                  <div class="title-colapse-green">{{dtgr.group +  ' - ' + dtgr.totalPavimento + ' Pavimentos'}}</div>
                </div>
                <div class="componente d-flex w-50 justify-content-end">
                  <div class="mr-4 mt-1 d-flex">{{dtgr.countTotal}} Apartamento(s)</div>
                <i v-if="!changeAngel" class="fas fa-angle-down arrow-angel"></i>
                <i v-if="changeAngel" class="fas fa-angle-up arrow-angel"></i>
              </div>
              </div>
            </b-card-header>
            <b-collapse :id="dtgr.group.replace(' ','')" :accordion="dtgr.group.replace(' ','')" role="tabpanel">
              <b-card-body>
                  <Colapsetower :dataEnterprise="dataEnterprise"
                   v-on:load="$emit('load')" :dataType="dataType" :dataGroup="dataGroup" v-for="(locality, i) in dtgr.localitys" :name="locality" :key="i" :status="enumStatus"
                   :countapr="getCountApr(dtgr.group,locality)" :dataTable="getByLocalityAndGroup(dtgr.group,locality)"   :i="i">
                   </Colapsetower>
              </b-card-body>
            </b-collapse>
          </b-card>
</div>

</template>

<script>
import Towerscourtacording from './towerscourtacording'
export default Towerscourtacording
</script>

<style scoped>
.head-mes{
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: space-between;
}

.title-left{
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
}

.title-colapse-green{
  font-size: 15px;
  color: #008148;
  font-weight: bold;
}

.componente{
  font-size: 15px;
  color: black;
  padding-top: 9px;
  padding-left: 15px;
}

.arrow-angel{
  font-size: 30px;
  color: black;
  padding-right: 20px;
  padding-bottom: 10px;
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/enterprise/components/towerscourtacording/towerscourtacording.vue